export default __webpack_public_path__ + "static/media/torii-sunset.b628d541.gif";